import { useContext, useReducer } from "react";
import { IParamQuery } from "../../models/param/query";
import { ICreateParam, IUpdateParam } from "../../models/param/request";
import { IParam } from "../../models/param/resopnse";
import EndPoints from "../../services/end-points";
import { execute } from "../../utils/helpers/execute";
import ParamContext, { internalState } from "./context";
import reducer from "./reducer";
import CategoryContext from "../category/context";
export interface IProps {
  children: React.ReactNode;
}
const ParamContextProvider: React.FC<IProps> = (props) => {
  const { actions } = useContext(CategoryContext);

  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async (attrId: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.param.getAllParams(
          attrId,
          // state?.query
          {
            perPage: -1,
          }
        );

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (attrId: number, paramId: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.param.getParam(attrId, paramId);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IParam) => {
    dispatch({ type: "SET_DETAILS", payload: { details: data } });
  };

  const createParam = async (attrId: number, request: ICreateParam) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.param.createParam(attrId, request);
        actions.getAllData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateParam = async (
    attrId: number,
    paramId: number,
    request: IUpdateParam
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.param.updateParam(attrId, paramId, request);
        actions.getAllData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const deleteParam = async (attrId: number, paramId: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.param.deleteParam(attrId, paramId);
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IParamQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
  // const exportExcel = async (request: any) => {
  //   await execute({
  //     callback: async () => {
  //       dispatch({
  //         type: "LOADING",
  //         payload: { loading: "create" },
  //       });
  //       const data = await EndPoints.Param.exportExcel(
  //         request,
  //         state.query
  //       );
  //       const url = window.URL.createObjectURL(new Blob([data.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setParam(
  //         "download",
  //         `Params-${moment().format("yyyy-MM-d")}.xlsx`
  //       );
  //       document.body.appendChild(link);
  //       link.click();
  //     },
  //     fallback: (error) => {},
  //     finallyCallback: () => {
  //       dispatch({
  //         type: "LOADING",
  //         payload: { loading: "create" },
  //       });
  //     },
  //     throwException: true,
  //   });
  // };

  return (
    <ParamContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,

          createParam,
          updateParam,
          deleteParam,
          // exportExcel,

          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </ParamContext.Provider>
  );
};

export default ParamContextProvider;
